import { isBoolean as _isBoolean, isString as _isString } from 'lodash';

import { ERR_DYNAMIC_VALIDATE_PREVIEW_SESSION } from '../../constants/Errors';

const validatePreviewSession = (session) => {
    try {
        const { autoSave, template } = session;
        const sessionKeys = Object.keys(session);

        // authorization - we should not pass any jwt token when on public preview
        if (sessionKeys.includes('authorization')) {
            return new Error(
                ERR_DYNAMIC_VALIDATE_PREVIEW_SESSION('authorization', 'should not be passed to public preview')
            );
        }

        // controls - controlls will be disabled for public preview
        if (sessionKeys.includes('controls')) {
            return new Error(ERR_DYNAMIC_VALIDATE_PREVIEW_SESSION('controls', 'disabled for public preview'));
        }

        // autoSave - should either not be passed or false
        if (autoSave !== undefined && _isBoolean(autoSave) && autoSave === true) {
            return new Error(ERR_DYNAMIC_VALIDATE_PREVIEW_SESSION('autoSave', 'should be false'));
        }

        // template - should either not be passed or a string
        if (template !== undefined && !_isString(template)) {
            return new Error(ERR_DYNAMIC_VALIDATE_PREVIEW_SESSION('template', 'should be a string'));
        }

        return null;
    } catch (err) {
        return err;
    }
};

export default validatePreviewSession;
